import type {OrgEditPermissions, PropertyDefinition} from '@github-ui/custom-properties-types'
import {customPropertyDetailsPath} from '@github-ui/paths'
import {Link} from '@github-ui/react-core/link'
import {Box, Button} from '@primer/react'

import {useCurrentOrg} from '../contexts/CurrentOrgRepoContext'
import {DefinitionsLimitBanner, isDefinitionsLimitReached} from './Banners'
import {PageHeader} from './PageHeader'
import {PropertiesPageTabs} from './PropertiesPageTabs'

export function PropertiesHeaderPageTabs({
  permissions,
  definitions,
}: {
  permissions: OrgEditPermissions
  definitions: PropertyDefinition[]
}) {
  const definitionLimitReached = isDefinitionsLimitReached(definitions)
  const canCreateProperty = !definitionLimitReached && (permissions === 'all' || permissions === 'definitions')

  return (
    <>
      <Header canCreateProperty={canCreateProperty} />
      {definitionLimitReached && (
        <Box sx={{mb: 2}}>
          <DefinitionsLimitBanner />
        </Box>
      )}
      {permissions === 'all' && <PropertiesPageTabs permissions={permissions} definitionsCount={definitions.length} />}
    </>
  )
}

function Header({canCreateProperty}: {canCreateProperty: boolean}) {
  const org = useCurrentOrg()

  return (
    <PageHeader
      title={
        <Box as="h2" sx={{fontWeight: 400}}>
          Custom properties
        </Box>
      }
      subtitle="Custom properties allow you to decorate your repositories with information such as compliance frameworks, data
      sensitivity, or project details."
      actions={
        canCreateProperty && (
          <Button
            as={Link}
            to={customPropertyDetailsPath({org: org.login})}
            variant="primary"
            data-testid="add-definition-button"
          >
            New property
          </Button>
        )
      }
    />
  )
}

try{ PropertiesHeaderPageTabs.displayName ||= 'PropertiesHeaderPageTabs' } catch {}
try{ Header.displayName ||= 'Header' } catch {}